// extracted by mini-css-extract-plugin
var _1 = "PauseSoldSubscriptionDialog_bookingsList__R7zEQ";
var _2 = "PauseSoldSubscriptionDialog_bookingsListTitle__leshj";
export { _1 as "bookingsList", _2 as "bookingsListTitle" }
